import React from "react";
import Modal from "react-modal";
import { Button } from "../../../common/Button/Button";
import { NavButtons } from "../../../common/NavButtons/NavButtons";
// import { Input, ControlledInput } from "../../../common/Input/Input";
import ModalContent from "../../../common/Modal/ModalContent";
import Spinner from "../../../common/Spinner/Spinner";
import { User, Calendar, X } from "react-feather";
import HandleRequestDropdown from "./HandleRequestDropdown";
// import CreateUserModal from './../../Users/CreateUserModal';
import ReactDatePicker from "react-datepicker";
import RequestStateUpdateDropdown from "./RequestStateUpdateDropdown";
import { useEffect } from "react";
import find from "lodash/find";
import api from "../../../utils/api";
import { useState } from "react";
import AuditLogDropdown from "./AuditLogDropdown";
import StateAuditLogDropdown from "./StateAuditLogDropdown";
import { getServiceTypesMaster } from "../../../utils/localStorage";
import { URL_CALCULATOR } from "../../../utils/urls";

import { getUser } from "../../../utils/localStorage";

import SelectCatalogueModal from "./SelectCatalogueModal";
import NeftModal from "./NeftModal";
import CentralizedNotesModal from "./CentralizedNotesModal";

import moment from "moment";
import ServiceRequestList from "./ServiceRequestList";
import { DND_LINK } from "../../../utils/constants";
import { Info} from "react-feather";
import Select from "react-select";
import CentralizedSMSLogModal from "./CentralizedSMSLogModel";
import ESPSMSTrail from "../../../containers/EServicePartnerServiceRequests/ESPSMSTrail";

Modal.setAppElement("#root");

export default function ServiceRequestDetailsModal({
	serviceRequestReadOnlyData,
	serviceRequestEditableData,
	...props
}) {
	const [auditLog, setAuditLog] = useState([]);

	const { nResourceInstanceId } = serviceRequestReadOnlyData;
	const { bMovedToSPM } = serviceRequestReadOnlyData;
	const [callButtonColor, setCallButtonColor] = useState("red");
	const [stateChangeLog, setStateChangeLog] = useState();

	const [showViewAllNotesModal, setShowViewAllNotesModal] = useState(false);
	const toggleViewAllNotesModal = () => {
		setShowViewAllNotesModal(!showViewAllNotesModal);
	};

	const [showViewAllSMSModal, setShowViewAllSMSModal] = useState(false);
	const toggleViewAllSMSModal = () => {
		setShowViewAllSMSModal(!showViewAllSMSModal);
	};


	useEffect(() => {
		if (!nResourceInstanceId) return;
		/*api.getAuditLog(nResourceInstanceId).then(({ data }) => {
			setAuditLog(data);
		});*/

		let payload={nResourceInstanceId:nResourceInstanceId};
		api.getESPNotesLogByServiceId(payload).then(({ data }) => {
			setAuditLog(data);
		});

		api.getStateAuditLog(nResourceInstanceId).then((d) => {
			setStateChangeLog(d.data);
		});
	}, [nResourceInstanceId, callButtonColor, serviceRequestReadOnlyData]);

	const getServiceName = (code) => {
		if (!code) return;
		const found = find(getServiceTypesMaster(), { sServiceCode: code });
		if (found) {
			return found.sServiceName;
		}
		return "";
	};

	const serviceCost = (request) => {
		if (!request) return;

		let fPackageOfferAmount="0";
		let fdeAsraPlatformCharges="0";
		let fPackageOfferGST="0";
		if(request.fPackageOfferAmount)
		{
			fPackageOfferAmount= request.fPackageOfferAmount.toString();
		}
		if(request.fPackageOfferGST)
		{
			fPackageOfferGST= request.fPackageOfferGST.toString();
		}
		if(request.fdeAsraPlatformCharges)
		{
			fdeAsraPlatformCharges= request.fdeAsraPlatformCharges.toString();
		}

		return "Pkg Service Cost With GST:"+fPackageOfferAmount.toString()+"\n"+"deAsra Platform Charges:"+fdeAsraPlatformCharges.toString()+"\n"+"GST On Platform Charges:"+fPackageOfferGST.toString();
	};

	const getCouponExpiryDate = (request)=>{
		return "Coupon Expiry Date: "+moment(request.dtCouponExpiryDate).format("lll");
	};

	const getDirection = (direction) => {
		{
			props.onNavigationButtonClick(direction);
		}
	};

	return (
		<Modal
			isOpen={props.isOpen}
			onRequestClose={props.toggleModal}
			ariaHideApp={false}
		>
			<ModalContent className="service-request-modal">
				<div className="p-2 modal-header-bar">
					<span>Service Request Details</span>
					<button
						type="button"
						className="close"
						aria-label="Close"
						onClick={props.toggleModal}
					>
						<X color="white" />
					</button>
				</div>
				<div
					className={`modal-body ${
						props.isLoadingInModal && "set-opacity"
					}`}
				>
					<div className="row">
						<div className="col-md-6">
							<div className="flex justify-content-between">
								<div className="flex">
									<div
										className="cursor-pointer"
										onClick={props.onUserProfileClick}
									>
										<User />
									</div>
									<div className="ml-3">
										<div>
											<span style={{float:'left'}}>
												{serviceRequestReadOnlyData.sFirstName}
												&nbsp;
												{serviceRequestReadOnlyData.sLastName}
											</span>
											<span style={{ float: 'right' }} className="moved-to-spm-text">
                                        {serviceRequestReadOnlyData.bMovedToSPM
                                            ? "Moved To SPM"
                                            : ""}
                                    </span>

											
										</div>
										<div style={{clear:'both'}}></div>
										<div>
											<span>{serviceRequestReadOnlyData.sEmailAddress} ( {serviceRequestReadOnlyData.sContactNumber} ) </span>
										</div>
										<div style={{clear:'both'}}></div>
										<div>
											<small>
												<i>
													Facilitator:{" "}
													{serviceRequestReadOnlyData.existing_service_facilitator
														? serviceRequestReadOnlyData
																.existing_service_facilitator[
																"email"
														]
														: "Not Available"}
												</i>
											</small>&nbsp;&nbsp;&nbsp;&nbsp;
											<small style={{marginLeft:"20px"}}>
												<i>
													Entry Point:{" "}
													{serviceRequestReadOnlyData.sEntryPoint
														? serviceRequestReadOnlyData.sEntryPoint
														: "Not Available"}
												</i>
											</small>
										</div>
										<div style={{clear:'both'}}></div>
										<div>
											<small>
												<i>
													EHH : {" "}
													{serviceRequestReadOnlyData.sExternalHHEmail
														? serviceRequestReadOnlyData.sExternalHHEmail+","
														: "Not Available,"}
												</i>
											</small>
											&nbsp;
											<small>
												<i>
													Org - {" "}
													{serviceRequestReadOnlyData.sEhhOrg
														? serviceRequestReadOnlyData.sEhhOrg+","
														: "Not Available,"}
												</i>
											</small>
											&nbsp;
											<small>
												<i>
													Contact - {" "}
													{serviceRequestReadOnlyData.sEhhContactNumber
														? serviceRequestReadOnlyData.sEhhContactNumber+""
														: "Not Available"}
												</i>
											</small>
										</div>
										<div>
											<small>
											Stay Engaged with EHH:{" "}
												{serviceRequestReadOnlyData.bStayEngagedWithEhh?"Yes" : "No"}
											</small>
											&nbsp;&nbsp;&nbsp;
											<small>
												Device Type:{" "}
												{serviceRequestReadOnlyData.sDeviceType ? (
													<>{serviceRequestReadOnlyData.sDeviceType}</>
												):(
													"Not Available"
												)}
											</small>
										</div>
										<div style={{clear:'both'}}></div>
										<div>
											<small>
												External Service Partner:{" "}
												{serviceRequestReadOnlyData.refExternalServicePartner?
												(
													<>
														{serviceRequestReadOnlyData.refExternalServicePartner}
														{serviceRequestReadOnlyData.ext_sp_org? (" ("+serviceRequestReadOnlyData.ext_sp_org+")"): ""}
													</>
												)
												: "NA"}
											</small>&nbsp;&nbsp;&nbsp;
											
										</div>
										<div style={{clear:'both'}}></div>
										<div>
											<small>
												Coupon Applied:{" "}{serviceRequestReadOnlyData.bCouponApplied ? 
												(
													<>
														{serviceRequestReadOnlyData.dtCouponExpiryDate?
														(
															<>
																{
																	new Date(serviceRequestReadOnlyData.dtCouponExpiryDate)<new Date()?
																	(
																		<>
																			<span style={{color:"red"}}>Yes</span>
																			<span title={getCouponExpiryDate(serviceRequestReadOnlyData)}>
																			<Info style={{marginLeft:"10px",width:"15px"}}/>
																			</span>
																		</>
																	):
																	(
																		<>
																			<span style={{color:"green"}}>Yes</span>
																			<span title={getCouponExpiryDate(serviceRequestReadOnlyData)}>
																			<Info style={{marginLeft:"10px",width:"15px"}}/>
																			</span>
																		</>
																	)
																}
															</>
														):
														(
															<>
																<span>Yes</span>
																<span title={"Coupon Expiry Date: Not Available"}>
																<Info style={{marginLeft:"10px",width:"15px"}}/>
																</span>
															</>
														)}
													</>
												):
												(
													<small><i>No</i></small>
												)}
											</small>&nbsp;&nbsp;&nbsp;
											<small>
												Coupon Code:{" "}{serviceRequestReadOnlyData.sCouponCode ? 
												(
													<>
														{serviceRequestReadOnlyData.dtCouponExpiryDate?
														(
															<>
																{
																	new Date(serviceRequestReadOnlyData.dtCouponExpiryDate)<new Date()?
																	(<span style={{color:"red"}}>{serviceRequestReadOnlyData.sCouponCode}</span>):
																	(<span style={{color:"green"}}>{serviceRequestReadOnlyData.sCouponCode}</span>)
																}
															</>
														):
														(
															<span>{serviceRequestReadOnlyData.sCouponCode}</span>
														)}
													</>
												):
												(
													<small><i>NA</i></small>
												)}
											</small>											
										</div>
										<div style={{clear:'both'}}></div>
										<div>
											<small>
												Coupon Discount Amount:{" "}{serviceRequestReadOnlyData.fDiscountAmount ? 
												(
													<>
														{serviceRequestReadOnlyData.dtCouponExpiryDate?
														(
															<>
																{
																	new Date(serviceRequestReadOnlyData.dtCouponExpiryDate)<new Date()?
																	(<span style={{color:"red"}}>{serviceRequestReadOnlyData.fDiscountAmount}</span>):
																	(<span style={{color:"green"}}>{serviceRequestReadOnlyData.fDiscountAmount}</span>)
																}
															</>
														):
														(
															<span>{serviceRequestReadOnlyData.fDiscountAmount}</span>
														)}									
													</>
												):
												(
													<small><i>NA</i></small>
												)}
											</small>&nbsp;&nbsp;&nbsp;
											<small>
												Service Cost After Discount:{" "}{serviceRequestReadOnlyData.fDiscountAmount ? 
												(
													<>
														{serviceRequestReadOnlyData.dtCouponExpiryDate?
														(
															<>
																{
																	new Date(serviceRequestReadOnlyData.dtCouponExpiryDate)<new Date()?
																	(<span style={{color:"red"}}>{serviceRequestReadOnlyData.fAmountFirst-serviceRequestReadOnlyData.fDiscountAmount}</span>):
																	(<span style={{color:"green"}}>{serviceRequestReadOnlyData.fAmountFirst-serviceRequestReadOnlyData.fDiscountAmount}</span>)
																}
															</>
														):
														(
															<span>{serviceRequestReadOnlyData.fAmountFirst-serviceRequestReadOnlyData.fDiscountAmount}</span>
														)}
														
													</>
												):
												(
													<small><i>NA</i></small>
												)}
											</small>
										</div>
										<div style={{clear:'both'}}></div>
										<small>
											Requested Date:{" "}
											{moment(
												serviceRequestReadOnlyData.dtRequested
											).format("lll") || (
												<small>
													<i>Not Available.</i>
												</small>
											)}
										</small>&nbsp;&nbsp;&nbsp;&nbsp;

										<small>
										Requested Call Back:{" "}
										{serviceRequestReadOnlyData.bRequestedCallBack ? (
												<>{"Yes"}</>
											):(<small>
												<i>NA</i>
											</small>)}
										</small>
										<br></br>
										{
											props.DNDDate ? (
											<small>
												DND Date:{" "}
												{moment(
													props.DNDDate
												).format("lll")}{" "}
											</small>
										) : (
											<small>
												DND Date: <i>Not Available.</i>
											</small>
										)}
										&nbsp;
										<small>
											<a href={DND_LINK} target="_blank">
												{" "}
												Extend DND
											</a>
										</small>

										<div>
											{getServiceName(
												serviceRequestReadOnlyData.sServiceCode
											)} ({serviceRequestReadOnlyData.sServiceDisplayName})
										</div>
										<div>
											<small>
												<i>
												Package/Offering Title:{" "}
													{serviceRequestReadOnlyData.sPackageOfferTitle? 
													<b>{serviceRequestReadOnlyData.sPackageOfferTitle}</b>: "Not Available"}
												</i>
											</small>
										</div>
										<div>
											<small>
												<i>
												Pkg/Off Instance ID:{" "}
												{serviceRequestReadOnlyData.nPackageInstanceId? 
													<>
														<span>
															<b>{serviceRequestReadOnlyData.nPackageInstanceId}</b>
														</span>
													</>
													: "NA"}
												</i>
											</small>&nbsp;&nbsp;&nbsp;&nbsp;
											<small>
												<i>
												Total Service Cost In Pkg:{" "}
												{serviceRequestReadOnlyData.fPackageOfferTotalServiceCharge? 
													<>
														<span>
															<b>{serviceRequestReadOnlyData.fPackageOfferTotalServiceCharge}</b> (Incl. GST)
														</span>
														<span style={{cursor:"pointer"}} title={serviceCost(serviceRequestReadOnlyData)}>
														<Info style={{marginLeft:"10px",width:"15px"}}/>
														</span>
													</>
													: "NA"}
												</i>
											</small>
										</div>
										<div className="flex">
											<div>
												<small className="ml-0">
													Sector:{" "}
													{serviceRequestReadOnlyData.business_sector_name || (
														<i>Not Available</i>
													)}
												</small>
												<small className="ml-4">
													Service Request ID :{" "}
													{
														serviceRequestReadOnlyData.nResourceInstanceId
													}
												</small>
											</div>
										</div>
										<div className={`request-state-dropdown-wrapper state-container`}>
											<RequestStateUpdateDropdown
												isLoading={props.isLoading}
												isUnsavedData={props.isUnsavedData}
												isAllFieldsArevallid={props.isAllFieldsArevallid}
												toggleUnsavedDataModal={props.toggleUnsavedDataModal}
												disableConfirmAndSave={
													serviceRequestReadOnlyData.refSRState ===
													"Cancelled"
														? "disable"
														: ""
												}
												isDisabled={
													serviceRequestReadOnlyData.bMovedToSPM
														? "disabled"
														: ""
												}
												paymentURL={
													serviceRequestReadOnlyData.urlPayment
												}
												nResourceInstanceId={
													serviceRequestReadOnlyData.nResourceInstanceId
												}
												paymentStatus={
													serviceRequestReadOnlyData.sPaymentStatus
												}
												paymentMode={
													serviceRequestReadOnlyData.sPaymentMode
												}
												currentState={
													serviceRequestReadOnlyData.refSRState
												}
												deliveryMode={
													serviceRequestReadOnlyData.sDeliveryMode
												}
												catalogueId={
													serviceRequestReadOnlyData.sCatalogueId
												}
												catalogueMode={props.catalogueMode}
												recalculateURL={
													serviceRequestReadOnlyData.sPaymentMode ===
														"No_Payment" ||
													serviceRequestReadOnlyData.sPaymentMode ===
														"SP_paid_service" ||
													serviceRequestReadOnlyData.refSRState ===
														"Payment Received" ||
													props.catalogueMode !== "DYNAMIC"
														? null
														: URL_CALCULATOR +
														String(
																serviceRequestReadOnlyData.nResourceInstanceId
														)
												}
												catalogueByServiceRequest={
													props.catalogueByServiceRequest
												}
												masterServiceRequestStates={
													props.masterServiceRequestStates
												}
												togglCatalogueModal={props.togglCatalogueModal}
												toggleNeftModal={props.toggleNeftModal}
												onSendPaymentLink={props.onSendPaymentLink}
												onChangeState={props.onChangeState}
												invoiceURL={
													serviceRequestReadOnlyData.urlInvoice
												}
												toggleConfirmationModal={props.toggleConfirmationModal}
												dtCouponExpiryDate={serviceRequestReadOnlyData.dtCouponExpiryDate}
												bCouponApplied={serviceRequestReadOnlyData.bCouponApplied}
												showConfirmationModal={props.showConfirmationModal}
												nPackageInstanceId={serviceRequestReadOnlyData.nPackageInstanceId}

											/>
										</div>

										<div className="follow-up-wrapper mt-2">
											{serviceRequestReadOnlyData.sFollowupAction || (
												<small>
													<i>No followup actions available.</i>
												</small>
											)}
										</div>
										<div className="follow-up-wrapper mt-2">
											{moment(
												serviceRequestReadOnlyData.dtFollowupOn
											).format("ll") || (
												<small>
													<i></i>
												</small>
											)}
											{/*  - {serviceRequestReadOnlyData.dtFollowupOn} */}
										</div>
										{props.error ? (
											<div className="form-error" style={{margin:"10px",marginLeft:"0px"}}>{props.error}</div>
										) : null}
										<div
											className="col-md-12"
											style={{
												marginTop: "10px",
												padding:"0px"
											}}
										>
											<div style={{float:"left",marginRight:"10px"}}>
												<AuditLogDropdown auditLog={auditLog} />
											</div>
											<div style={{float:"left",marginRight:"10px"}}>
												<StateAuditLogDropdown
													stateAuditLog={stateChangeLog}
												/>
											</div>
											<Button 
												onClick={toggleViewAllNotesModal}
												style={{float:"left",marginRight:"10px"}}
												>
												All Notes
											</Button>
											<ESPSMSTrail 
												nResourceInstanceId={nResourceInstanceId}
												isFromLPM={true}
											/>
											<Button 
												onClick={toggleViewAllSMSModal}
												style={{float:"left",marginRight:"5px"}}
												>
												All SMS
											</Button>
										</div>
									</div>
								</div>
							</div>
					</div>
					<div className="col-md-6">
						<div className="mt-2 lpm-service-details">
								<label style={{float:"left",marginRight:"5px"}}>
									Follow up on <span className="required">*</span>
								</label>
								<ReactDatePicker
									dateFormat="dd/MM/yyyy"
									selected={
										serviceRequestEditableData.dtFollowupOn
									}
									onChange={(date) =>
										props.onInputChange("dtFollowupOn", date)
									}
									minDate={new Date()}
								/>

								{
								serviceRequestReadOnlyData.refExternalServicePartner?(<>
									<label style={{float:"left",marginRight:"5px"}}>
									Need to talk to SP
									</label>
									<Select
										//placeholder="Select Need to talk to SP"
										options={props.needToTalkToSPOptions}
										onChange={props.setSelectedNeedToTalkToSPOption}
										value={props.selectedNeedToTalkToSPOption}
									></Select>
									</>
								):
								("")}
						</div>
						<div style={{clear:"both"}}></div>
						<div className="mt-2">
								<label>
									Follow up Actions{" "}
									<span className="required">*</span>
								</label>
								<div>
									<textarea
										name="sFollowupNotes"
										className="w-100 form-control rounded"
										value={
											serviceRequestEditableData.sFollowupNotes
										}
										onChange={({ target: { name, value } }) =>
											props.onInputChange(name, value)
										}
										style={{minHeight:"110px"}}
									/>
								</div>
						</div>
						
						<div className="mt-2">
							<label>
								Notes <span className="required">*</span>
							</label>
							<div>
								<textarea
									className="w-100 form-control rounded"
									name="sNotes"
									value={serviceRequestEditableData.sNotes}
									onChange={({ target: { name, value } }) =>
										props.onInputChange(name, value)
									}
									style={{minHeight:"110px"}}
								/>
							</div>
						</div>
						<div style={{clear:"both",margin:"10px"}}></div>
						<div style={{float:"left",marginRight:"15px"}}>
							<HandleRequestDropdown
								color={props.callButtonColor}
								onUpdateServiceRequest={
									props.onUpdateServiceRequest
								}
								bMovedToSPM={bMovedToSPM}
								disableConfirmAndSave={
									serviceRequestReadOnlyData.refSRState ===
									"Cancelled"
										? "disable"
										: ""
								}
							/>
						</div>
						<div className="float-left" style={{marginRight:"15px"}}>
								<Button
									disabled={
										serviceRequestReadOnlyData.bMovedToSPM ||
										serviceRequestReadOnlyData.refSRState ===
											"Cancelled"
									}
									onClick={
										() =>
											props.toggleCancellationReasonModal()
										// props.onChangeState("Cancelled")
									}
								>
									Cancel Service Request
								</Button>
						</div>
					</div>
					
				</div>
				<div style={{clear:"both"}}></div>
				<div className="row">
						<div className="col-md-12" style={{textAlign:"center",marginTop:"10px"}}>
							<NavButtons
								getDirection={getDirection}
								disablePrevious={() => {
									if (
										props.currentServiceRequestIndex ===
											0 ||
										props.serviceRequestList[
											serviceRequestReadOnlyData[
												"sEmailAddress"
											]
										].length === 1
									) {
										return "disablePrevious";
									} else {
										return "";
									}
								}}
								disableNext={() => {
									if (
										props.currentServiceRequestIndex ===
											props.serviceRequestList[
												serviceRequestReadOnlyData[
													"sEmailAddress"
												]
											].length -
												1 ||
										props.serviceRequestList[
											serviceRequestReadOnlyData[
												"sEmailAddress"
											]
										].length === 1
									) {
										return "disableNext";
									} else {
										return "";
									}
								}}
							></NavButtons>
						</div>
					</div>
					{props.isLoadingInModal && <Spinner className="center" />}
				</div>
			</ModalContent>
			<SelectCatalogueModal
				isLoading={props.isLoading}
				isDisabled={
					serviceRequestReadOnlyData.bMovedToSPM
						? "disable-modal"
						: ""
				}
				isOpen={props.isCatalogueModalOpen}
				catalogue={props.catalogueByServiceRequest}
				selectedCatalogue={props.selectedCatalogue}
				toggleModal={props.togglCatalogueModal}
				onCatalogueSelected={props.onCatalogueSelected}
				onSaveCatalogue={props.onSaveCatalogue}
			/>
			<NeftModal
				isLoading={props.isLoading}
				isDisabled={
					serviceRequestReadOnlyData.bMovedToSPM
						? "disable-modal"
						: ""
				}
				isOpen={props.isNeftModalOpen}
				toggleModal={props.toggleNeftModal}
				neftDetails={props.neftDetails}
				onInputChange={props.onNeftDetailsChanged}
				onSaveNeftDetails={props.onSaveNeftDetails}
				showSendNeftDetailsModal={props.showSendNeftDetailsModal}
				setShowSendNeftDetailsModal={props.setShowSendNeftDetailsModal}
				nResourceInstanceId={serviceRequestReadOnlyData.nResourceInstanceId}
			/>
			{
				showViewAllNotesModal&&
				(
					<CentralizedNotesModal
						isOpen={showViewAllNotesModal}
						toggleModal={toggleViewAllNotesModal}
						sEmailAddress={serviceRequestReadOnlyData.sEmailAddress}
					>
					</CentralizedNotesModal>
				)
			}

			{
				showViewAllSMSModal&&
				(
					<CentralizedSMSLogModal
						isOpen={showViewAllSMSModal}
						toggleModal={toggleViewAllSMSModal}
						sEmailAddress={serviceRequestReadOnlyData.sEmailAddress}
					>
					</CentralizedSMSLogModal>
				)
			}
		</Modal>
	);
}